/**
 * Efast Workbench - 订单 CRUD API 层
 * 从 orders_data.js 拆分，打破 orders_data ↔ orders_render 循环依赖
 */
import { Auth } from "./auth.js";

async function _orderFetch(url, options) {
  var token = Auth.getToken();
  if (!options) options = {};
  options.headers = Object.assign({
    "Content-Type": "application/json",
    "Authorization": "Bearer " + token
  }, options.headers || {});
  var resp = await fetch(url, options);
  if (resp.status === 401) { Auth.logout(); return null; }
  return resp;
}

async function fetchOrdersFromServer() {
  var resp = await _orderFetch("/api/orders");
  if (!resp) return [];
  var data = await resp.json();
  return data.orders || [];
}

async function saveOrderToServer(order) {
  var resp = await _orderFetch("/api/orders", {
    method: "POST",
    body: JSON.stringify(order)
  });
  if (!resp) throw new Error("保存失败");
  var data = await resp.json();
  if (!resp.ok) {
    throw new Error(data.error || "保存失败");
  }
  return data._action || "created";
}

async function syncCleanupOnServer(scannedIds) {
  var resp = await _orderFetch("/api/orders/sync-cleanup", {
    method: "POST",
    body: JSON.stringify({ scannedIds: scannedIds })
  });
  if (!resp) return;
  if (!resp.ok) { console.warn("[Efast Clean] cleanup skipped:", resp.status); return; }
  var data = await resp.json();
  console.log("[Efast Clean] 影子级数据清洗完毕。移除 " + data.removed + " 条，当前剩余: " + data.total + " 笔。");
}

async function deleteOrderFromServer(orderId) {
  var resp = await _orderFetch("/api/orders/" + orderId, { method: "DELETE" });
  if (!resp) throw new Error("删除失败");
  if (!resp.ok) {
    var err = await resp.json();
    throw new Error(err.error || "删除失败");
  }
}


async function syncBatch(orders, scannedIds) {
  var resp = await _orderFetch("/api/orders/sync-batch", {
    method: "POST",
    body: JSON.stringify({ orders: orders, scannedIds: scannedIds })
  });
  if (!resp) throw new Error("Batch sync failed");
  var data = await resp.json();
  if (!resp.ok) throw new Error(data.error || "Batch sync failed");
  return data;
}
export { fetchOrdersFromServer, saveOrderToServer, syncCleanupOnServer, deleteOrderFromServer, syncBatch };